import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { toSignal } from '@angular/core/rxjs-interop';
import { EmptyFallbackHtmlPipe } from '../../pipe/empty-fallback-html.pipe';
import { LocalDatePipe } from '@anihis/shared/src/pipes/local-date.pipe';

@Component({
  selector: 'anihis-note-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatTooltipModule,
    TranslocoModule,
    EmptyFallbackHtmlPipe,
    LocalDatePipe,
  ],
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteDialogComponent {
  public dialogRef = inject(MatDialogRef<NoteDialogComponent>);
  public data = inject(MAT_DIALOG_DATA) as any;
  private transloco = inject(TranslocoService);
  lang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });

  closeDialog(): void {
    this.dialogRef.close();
  }
}
